import {AllSystemConditions} from '../models/tcdd-train/all-system-conditions.model';
import {TcddSubSystem} from '../enums/tcdd-sub-system.enum';

export class TcddTrainConditions {
  public static getConditions(): AllSystemConditions {
    return {
      [TcddSubSystem.TRACTION_SYSTEM]: {
        main: [
          {
            id: 'traction-main-info-status',
            conditions: [
              (value: string | number): boolean => false, // fDriveForceAx3And4Total
              (value: string | number): boolean => false, // forceAppliedAx3And4total
              (value: string | number): boolean => false, // edBrakeForce
              (value: string | number): boolean => false, // VLimit
              (value: string | number): boolean => Number(value) === 0, // tractionNullZeroTorque
              (value: string | number): boolean => Number(value) === 1, // wheelCapInfoCheck
              (value: string | number): boolean => Number(value) === 0, // isCouplingProcessCompleted
              (value: string | number): boolean => Number(value) === 0, // isDecouplingDone
              (value: string | number): boolean => false // ASCActive
            ]
          },
          {
            id: 'traction-main-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // tractionInhibited
              (value: string | number): boolean => Number(value) === 1, // maximumSpeedExceeded
              (value: string | number): boolean => Number(value) === 1, // openingError
              (value: string | number): boolean => Number(value) === 1 // tkysCerCommunicationError
            ]
          }
        ],
        sub: [
          {
            id: 'traction-sub-info-status',
            conditions: [
              (value: string | number): boolean => false, // tcuVacuumOpeningCommandBypass
              (value: string | number): boolean => Number(value) === 0, // sprayEnabled
              (value: string | number): boolean => false // zeroSpeedBypass
            ]
          },
          {
            id: 'traction-sub-info-motor-status',
            conditions: [
              (value: string | number): boolean => false, // forceAvmAx3
              (value: string | number): boolean => false, // forceAvmAx4
              (value: string | number): boolean => false, // forceAppliedAx3
              (value: string | number): boolean => false, // forceAppliedAx4
              (value: string | number): boolean => false, // velMotorAx3
              (value: string | number): boolean => false, // velMotorAx4
              (value: string | number): boolean => Number(value) > 140, // tempMotorAx3
              (value: string | number): boolean => Number(value) > 140, // tempMotorAx4
              (value: string | number): boolean => false, // contactorMotorCooling1Inserted
              (value: string | number): boolean => false, // contactorMotorCooling2Inserted
              (value: string | number): boolean => false, // flowDetectorDuct1
              (value: string | number): boolean => false // flowDetectorDuct2
            ]
          },
          {
            id: 'traction-sub-info-inverter-status',
            conditions: [
              (value: string | number): boolean => Number(value) > 85, // tempTrcIn1
              (value: string | number): boolean => Number(value) > 85 // tempTrcIn2
            ]
          },
          {
            id: 'traction-sub-info-rectifier-status',
            conditions: [
              (value: string | number): boolean => Number(value) > 85 // tempTrcRec
            ]
          },
          {
            id: 'traction-sub-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // isolationMonitoringFault
              (value: string | number): boolean => Number(value) === 1, // failureTcu
              (value: string | number): boolean => Number(value) === 0, // lcuOk
              (value: string | number): boolean => Number(value) === 0, // cutOffTraction
              (value: string | number): boolean => Number(value) === 1, // failureTransformer
              (value: string | number): boolean => Number(value) === 1, // cutOffBypass
              (value: string | number): boolean => Number(value) === 1, // lcuMaintenance1
              (value: string | number): boolean => Number(value) === 1 // lcuMaintenance2
            ]
          },
          {
            id: 'traction-sub-info-motor-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // sMotorAx3
              (value: string | number): boolean => Number(value) === 0, // sMotorAx4
              (value: string | number): boolean => Number(value) === 1, // motor1CoolingFault
              (value: string | number): boolean => Number(value) === 1 // motor2CoolingFault
            ]
          },
          {
            id: 'traction-sub-info-inverter-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // sInvAx3
              (value: string | number): boolean => Number(value) === 0 // sInvAx4
            ]
          },
          {
            id: 'traction-sub-info-rectifier-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // sTractionRectifierL1Ok
              (value: string | number): boolean => Number(value) === 0 // sTractionRectifierL2Ok
            ]
          }
        ]
      },

      [TcddSubSystem.SIGNALIZATION_SYSTEM]: {
        main: [
          {
            id: 'signalization-main-info-status',
            conditions: []
          },
          {
            id: 'signalization-main-info-error',
            conditions: []
          }
        ],
        sub: [
          {
            id: 'signalization-sub-info-status',
            conditions: []
          },
          {
            id: 'signalization-sub-info-safety-related-inputs-status',
            conditions: [
              (value: string | number): boolean => false, // sleeping
              (value: string | number): boolean => false, // isolationStatusNormal
              (value: string | number): boolean => false, // cabStatusA
              (value: string | number): boolean => false, // cabStatusB
              (value: string | number): boolean => false, // direction
              (value: string | number): boolean => false, // tractionStatusForEtcs
              (value: string | number): boolean => false, // magneticValvesIsolation
              (value: string | number): boolean => false, // emergencyBrakeFeedback1
              (value: string | number): boolean => false, // emergencyBrakeFeedback2
              (value: string | number): boolean => false, // brakeMode
              (value: string | number): boolean => false, // atsPower
              (value: string | number): boolean => false, // atsActivationFeedback
              (value: string | number): boolean => false // atsActive
            ]
          },
          {
            id: 'signalization-sub-info-not-safety-related-inputs-status',
            conditions: [
              (value: string | number): boolean => false // trainTractionReady
            ]
          },
          {
            id: 'signalization-sub-info-safety-related-outputs-status',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // emergencyBrake1
              (value: string | number): boolean => Number(value) === 0, // emergencyBrake2
              (value: string | number): boolean => Number(value) === 0, // tractionCutOff1
              (value: string | number): boolean => Number(value) === 0, // tractionCutOff2
              (value: string | number): boolean => Number(value) === 1, // atsIsolation
              (value: string | number): boolean => Number(value) === 1, // atsActivation1
              (value: string | number): boolean => Number(value) === 1 // atsActivation2
            ]
          },
          {
            id: 'signalization-sub-info-not-safety-related-outputs-status',
            conditions: [
              (value: string | number): boolean => false // isolation
            ]
          },
          {
            id: 'signalization-sub-info-dmi-status',
            conditions: [
              (value: string | number): boolean => Number(value) === 3 || Number(value) === 4 // dmiStatus
            ]
          },
          {
            id: 'signalization-sub-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // rtm
              (value: string | number): boolean => Number(value) === 1, // jru
              (value: string | number): boolean => Number(value) === 1, // psu
              (value: string | number): boolean => Number(value) === 1, // evc
              (value: string | number): boolean => Number(value) === 1, // nvc
              (value: string | number): boolean => Number(value) === 1, // btm
              (value: string | number): boolean => Number(value) === 1, // tacho1Broken
              (value: string | number): boolean => Number(value) === 1, // tacho2Broken
              (value: string | number): boolean => Number(value) === 1, // doppler1Broken
              (value: string | number): boolean => Number(value) === 1 // doppler2Broken
            ]
          },
          {
            id: 'signalization-sub-info-dmi-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // dmiError
              (value: string | number): boolean => Number(value) === 1, // dmiTemperatureError
              (value: string | number): boolean => Number(value) === 1 // dmiFanError
            ]
          }
        ]
      },

      [TcddSubSystem.COMMUNICATION_SYSTEM]: {
        main: [
          {
            id: 'communication-main-info-status',
            conditions: []
          },
          {
            id: 'communication-main-info-uds-uib-status',
            conditions: [
              (value: string | number): boolean => false, // softwareVersion
              (value: string | number): boolean => false, // mvbStatus
              (value: string | number): boolean => false, // memoryUsage
              (value: string | number): boolean => false // temperature
            ]
          },
          {
            id: 'communication-main-info-error',
            conditions: []
          },
          {
            id: 'communication-main-info-uds-uib-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // gsmError
              (value: string | number): boolean => Number(value) === 1, // mvbError
              (value: string | number): boolean => Number(value) === 1, // urukConnectionError
              (value: string | number): boolean => Number(value) === 1, // powerError
              (value: string | number): boolean => Number(value) === 1, // temperatureError
              (value: string | number): boolean => Number(value) === 1 // otherError
            ]
          }
        ],
        sub: [
          {
            id: 'communication-sub-info-status',
            conditions: [
              (value: string | number): boolean => false, // unitRole
              (value: string | number): boolean => Number(value) === 0, // bcu
              (value: string | number): boolean => Number(value) === 0, // tcu
              (value: string | number): boolean => Number(value) === 0, // ccu
              (value: string | number): boolean => Number(value) === 0, // hmi
              (value: string | number): boolean => Number(value) === 0, // wtb-mvb
              (value: string | number): boolean => Number(value) === 0 // eventRecorder
            ]
          },
          {
            id: 'communication-sub-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // canRiomError
              (value: string | number): boolean => Number(value) === 3, // mvbRiom1Error
              (value: string | number): boolean => Number(value) === 3, // mvbRiom2Error
              (value: string | number): boolean => Number(value) === 3, // mvbRiom3Error
              (value: string | number): boolean => Number(value) === 3, // mvbRiom4Error
              (value: string | number): boolean => Number(value) === 1, // papisError
              (value: string | number): boolean => Number(value) === 1 // cctvError
            ]
          },
          {
            id: 'communication-sub-info-air-condition-system-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // driverHvacCommunicationError
              (value: string | number): boolean => Number(value) === 1, // hvac1CommunicationError
              (value: string | number): boolean => Number(value) === 1 // hvac2CommunicationError
            ]
          },
          {
            id: 'communication-sub-info-door-system-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor1CommunicationErrorTemplate
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor2CommunicationErrorTemplate
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor3CommunicationErrorTemplate
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor4CommunicationErrorTemplate
              (value: string | number): boolean => Number(value) === 1, // isEndDoor1CommunicationErrorTemplate
              (value: string | number): boolean => Number(value) === 1, // isEndDoor2CommunicationErrorTemplate
              (value: string | number): boolean => Number(value) === 1, // isInnerDoor1CommunicationErrorTemplate
              (value: string | number): boolean => Number(value) === 1, // isInnerDoor2CommunicationErrorTemplate
              (value: string | number): boolean => Number(value) === 1 // isBistroDoorCommunicationErrorTemplate
            ]
          },
          {
            id: 'communication-sub-info-other-system-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1 // toiletCommunicationError
            ]
          }
        ]
      },

      [TcddSubSystem.BRAKE_SYSTEM]: {
        main: [
          {
            id: 'brake-main-info-status',
            conditions: [
              (value: string | number): boolean => false, // edBarRequest
              (value: string | number): boolean => false // sHmiPbIsolationApprove
            ]
          },
          {
            id: 'brake-main-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // validBrakeTestTimeExpired
              (value: string | number): boolean => Number(value) === 1, // validBrakeTestTimeHalfExpired
              (value: string | number): boolean => Number(value) === 1, // sifaIsolation
              (value: string | number): boolean => Number(value) === 1, // parkBrakeIsolation
              (value: string | number): boolean => Number(value) === 1, // majorBrPark
              (value: string | number): boolean => Number(value) === 1, // brakeCommunicationError
              (value: string | number): boolean => Number(value) === 1 // tkysBrakeCommunicationError
            ]
          }
        ],
        sub: [
          {
            id: 'brake-sub-info-status',
            conditions: [
              (value: string | number): boolean => Number(value) < 7, // mrpPress
              (value: string | number): boolean => false, // bpPress
              (value: string | number): boolean => false, // SPBEmerRelConf
              (value: string | number): boolean => false, // isolationCockParkingBrakeIsolated1
              (value: string | number): boolean => false, // isolationCockParkingBrakeIsolated2
              (value: string | number): boolean => false, // pressureGovernorPBReleased
              (value: string | number): boolean => Number(value) === 0, // pressureGovernorDetectionEmergencyBrake
              (value: string | number): boolean => false, // SIFA1PositionHandle
              (value: string | number): boolean => false, // SIFA1TractionControl
              (value: string | number): boolean => false, // SIFA2PositionHandle
              (value: string | number): boolean => false, // SIFA2TractionControl
              (value: string | number): boolean => false, // isolationCockSanding
              (value: string | number): boolean => false, // isolationCockBPToMRPBypass
              (value: string | number): boolean => false, // isolationCockBPTest
              (value: string | number): boolean => false, // isolationCock1BPControl
              (value: string | number): boolean => false, // isolationCock2BPControl
              (value: string | number): boolean => false // pressureGovernorIndirectBrakeControl
            ]
          },
          {
            id: 'brake-sub-info-bogie-status',
            conditions: [
              (value: string | number): boolean => false, // cPressTB
              (value: string | number): boolean => false, // cPressMB
              (value: string | number): boolean => false, // isolationCockPneumaticBrakeIsolatedTB
              (value: string | number): boolean => false, // isolationCockPneumaticBrakeIsolatedMB
              (value: string | number): boolean => false, // isolationCockDirectBrakeIsolatedTB
              (value: string | number): boolean => false, // isolationCockDirectBrakeIsolatedMB
              (value: string | number): boolean => false, // pressureGovernorBrakeUnitAppliedReleasedTB
              (value: string | number): boolean => false // pressureGovernorBrakeUnitAppliedReleasedMB
            ]
          },
          {
            id: 'brake-sub-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // EBCU_C_FCTOK
              (value: string | number): boolean => Number(value) === 1, // diaWspTestAborted
              (value: string | number): boolean => Number(value) === 1, // sBCUEblOpenPb
              (value: string | number): boolean => Number(value) === 1, // diaMvbErrorTcu
              (value: string | number): boolean => Number(value) === 1, // diaMvbErrorBcu
              (value: string | number): boolean => Number(value) === 1, // diaMvbErrorVcu
              (value: string | number): boolean => Number(value) === 0, // group44CBProtection
              (value: string | number): boolean => Number(value) === 0, // compressorMVCBProtection
              (value: string | number): boolean => Number(value) === 1, // isolationCockAirSupply
              (value: string | number): boolean => Number(value) === 1, // diaSandingDisturbed
              (value: string | number): boolean => Number(value) === 1, // diaPSensorMrp
              (value: string | number): boolean => Number(value) === 1, // diaPSensorBp
              (value: string | number): boolean => Number(value) === 1 // relayEmergencyLoop
            ]
          },
          {
            id: 'brake-sub-info-bogie-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // diaCPressHoseBrakeTB
              (value: string | number): boolean => Number(value) === 1, // diaCPressHoseBrakeMB
              (value: string | number): boolean => Number(value) === 1, // diaBrakeNotReleasedTB
              (value: string | number): boolean => Number(value) === 1, // diaBrakeNotReleasedMB
              (value: string | number): boolean => Number(value) === 1, // diaBrakeNotAppliedTB
              (value: string | number): boolean => Number(value) === 1, // diaBrakeNotAppliedMB
              (value: string | number): boolean => Number(value) === 1, // diaDirectBrakeDistTB
              (value: string | number): boolean => Number(value) === 1, // diaDirectBrakeDistMB
              (value: string | number): boolean => Number(value) === 0, // pressureGovernorPressureAirSuspensionTB
              (value: string | number): boolean => Number(value) === 0, // pressureGovernorPressureAirSuspensionMB
              (value: string | number): boolean => Number(value) === 1, // diaAirSuspPressInvalidTB
              (value: string | number): boolean => Number(value) === 1, // diaAirSuspPressInvalidMB
              (value: string | number): boolean => Number(value) === 1, // diaWspFailureTB
              (value: string | number): boolean => Number(value) === 1 // diaWspFailureMB
            ]
          }
        ]
      },

      [TcddSubSystem.POWER_VOLTAGE_SYSTEM]: {
        main: [
          {
            id: 'power-voltage-main-info-status',
            conditions: [
              (value: string | number): boolean => false, // pArac
              (value: string | number): boolean => Number(value) === 2 || Number(value) === 6 || Number(value) === 7, // vacuumStatus
              (value: string | number): boolean => Number(value) === 1 || Number(value) === 4 || Number(value) === 5, // pantoStatus
              (value: string | number): boolean => false, // workshopContactor
              (value: string | number): boolean => false, // mediumVoltageBackupActivated1Vehicle
              (value: string | number): boolean => false, // mediumVoltageBackupActivated2Vehicle
              (value: string | number): boolean => false // mediumVoltageBackupActivated3Vehicle
            ]
          },
          {
            id: 'power-voltage-main-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // vacuumClosedPantoCannotBeRaised
              (value: string | number): boolean => Number(value) === 1, // multipleVacuumActive
              (value: string | number): boolean => Number(value) === 1, // vacuumClosedOnInactivePanto
              (value: string | number): boolean => Number(value) === 1, // multiplePantographCannotBeRaised
              (value: string | number): boolean => Number(value) === 1, // hvDisconnectorCannotBeIsolated
              (value: string | number): boolean => Number(value) === 1, // hvDisconnectorCannotBeEngaged
              (value: string | number): boolean => Number(value) === 1, // diaPantoComp
              (value: string | number): boolean => Number(value) === 1, // transformerLevel2Error
              (value: string | number): boolean => Number(value) === 1, // hvConfigError
              (value: string | number): boolean => Number(value) === 1, // mediumVoltageCriticalError
              (value: string | number): boolean => Number(value) === 1, // mediumVoltageContactorControlError
              (value: string | number): boolean => Number(value) === 1, // mediumVoltageErrorCabChange
              (value: string | number): boolean => Number(value) === 1, // majorUnderVoltageError
              (value: string | number): boolean => Number(value) === 1, // highCurrentVacuumError
              (value: string | number): boolean => Number(value) === 1, // allPantographIsolated
              (value: string | number): boolean => Number(value) === 1 // isParkModeActive
            ]
          }
        ],
        sub: [
          {
            id: 'power-voltage-sub-info-status',
            conditions: [
              (value: string | number): boolean => Number(value) < 90, // measuringBatteryVoltage
              (value: string | number): boolean => false, // transducerHvVoltageVcbIn
              (value: string | number): boolean => false, // transducerHvCurrent
              (value: string | number): boolean => Number(value) > 40, // tempBattery
              (value: string | number): boolean => false, // aBatteryCharger
              (value: string | number): boolean => Number(value) > 75, // tractionTransformerTemperatureTcu
              (value: string | number): boolean => false, // sApu3phOut
              (value: string | number): boolean => Number(value) === 0, // sApuOk
              (value: string | number): boolean => false, // hvPresenceToAps
              (value: string | number): boolean => Number(value) === 0, // sBatteryChar
              (value: string | number): boolean => false, // manualPowerSupplyPrivilegedLoadLp
              (value: string | number): boolean => false, // contactorPrivilegeLoadLp
              (value: string | number): boolean => Number(value) === 1, // tempFaultApuInv
              (value: string | number): boolean => Number(value) === 1, // tempFaultApuRec
              (value: string | number): boolean => false, // inhibitAps
              (value: string | number): boolean => false, // highDisconnectorOpenedIsolated
              (value: string | number): boolean => Number(value) === 0, // hvDisconnectorClose
              (value: string | number): boolean => false, // pantographInsulated
              (value: string | number): boolean => Number(value) === 0, // earthingSwitchOpenServicePosition
              (value: string | number): boolean => false, // vcbClosed
              (value: string | number): boolean => false // pressurePs1SafeguardAdd
            ]
          },
          {
            id: 'power-voltage-sub-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // tractionTransformerOverPressure11
              (value: string | number): boolean => Number(value) === 1, // tractionTransformerOverTemp1
              (value: string | number): boolean => Number(value) === 1, // tractionTransformerOverTemp2
              (value: string | number): boolean => Number(value) === 1, // tractionTransformerOilFlow
              (value: string | number): boolean => Number(value) === 1, // tractionTransformerOilLevel
              (value: string | number): boolean => Number(value) === 0, // fastLowering
              (value: string | number): boolean => Number(value) === 1, // openVcbForHighCurrent
              (value: string | number): boolean => Number(value) === 0 // fastOpeningFromSignallingTcu
            ]
          }
        ]
      },

      [TcddSubSystem.AIR_CONDITION_SYSTEM]: {
        main: [
          {
            id: 'air-condition-main-info-status',
            conditions: [
              (value: string | number): boolean => false // tmpOutside
            ]
          },
          {
            id: 'air-condition-main-info-error',
            conditions: []
          }
        ],
        sub: [
          {
            id: 'air-condition-sub-info-status',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // hvacsInhibition
              (value: string | number): boolean => false // closeDumper
            ]
          },
          {
            id: 'air-condition-sub-info-driver-status',
            conditions: [
              (value: string | number): boolean => false, // driverHVACTargetTemperature
              (value: string | number): boolean => false, // driverHvacAvgInsideTemperature
              (value: string | number): boolean => false, // driverHVACMode
              (value: string | number): boolean => false // driverHvacClosed
            ]
          },
          {
            id: 'air-condition-sub-info-passenger-status',
            conditions: [
              (value: string | number): boolean => false, // hvac1AndHvac2TargetTemperature
              (value: string | number): boolean => false, // hvac1AvgInsideTemperature
              (value: string | number): boolean => false, // hvac2AvgInsideTemperature
              (value: string | number): boolean => false, // hvac1Mode
              (value: string | number): boolean => false, // hvac2Mode
              (value: string | number): boolean => false, // hvac1Closed
              (value: string | number): boolean => false // hvac2Closed
            ]
          },
          {
            id: 'air-condition-sub-info-error',
            conditions: []
          },
          {
            id: 'air-condition-sub-info-passenger-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // driverHvacCommunicationError
              (value: string | number): boolean => Number(value) === 1, // driverHvacMajorError
              (value: string | number): boolean => Number(value) === 1 // driverHvacMinorError
            ]
          },
          {
            id: 'air-condition-sub-info-passenger-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // hvac1CommunicationError
              (value: string | number): boolean => Number(value) === 1, // hvac2CommunicationError
              (value: string | number): boolean => Number(value) === 1, // hvac1MajorError
              (value: string | number): boolean => Number(value) === 1, // hvac2MajorError
              (value: string | number): boolean => Number(value) === 1, // hvac1MinorError
              (value: string | number): boolean => Number(value) === 1 // hvac2MinorError
            ]
          }
        ]
      },

      [TcddSubSystem.DOOR_SYSTEM]: {
        main: [
          {
            id: 'door-main-info-status',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // relayControlDoorsLoopSka1
              (value: string | number): boolean => Number(value) === 0, // relayControlDoorsLoopSka2
              (value: string | number): boolean => Number(value) === 1, // slDoorControlByPassSka1
              (value: string | number): boolean => Number(value) === 1 // slDoorControlByPassSka2
            ]
          },
          {
            id: 'door-main-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1 // internalDoorLevel2Error
            ]
          }
        ],
        sub: [
          {
            id: 'door-sub-info-status',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor1OutOfService
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor2OutOfService
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor3OutOfService
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor4OutOfService
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor1MajorError
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor2MajorError
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor3MajorError
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor4MajorError
              (value: string | number): boolean => false, // isOuterDoor1MinorError
              (value: string | number): boolean => false, // isOuterDoor2MinorError
              (value: string | number): boolean => false, // isOuterDoor3MinorError
              (value: string | number): boolean => false, // isOuterDoor4MinorError
              (value: string | number): boolean => false, // isOuterDoor1FullyOpen
              (value: string | number): boolean => false, // isOuterDoor2FullyOpen
              (value: string | number): boolean => false, // isOuterDoor3FullyOpen
              (value: string | number): boolean => false, // isOuterDoor4FullyOpen
              (value: string | number): boolean => false, // isOuterDoor1Enabled
              (value: string | number): boolean => false, // isOuterDoor2Enabled
              (value: string | number): boolean => false, // isOuterDoor3Enabled
              (value: string | number): boolean => false, // isOuterDoor4Enabled
              (value: string | number): boolean => false, // isOuterDoor1ClosedAndLocked
              (value: string | number): boolean => false, // isOuterDoor2ClosedAndLocked
              (value: string | number): boolean => false, // isOuterDoor3ClosedAndLocked
              (value: string | number): boolean => false, // isOuterDoor4ClosedAndLocked
              (value: string | number): boolean => false, // isEndDoor1LockedCloseAndLockedOpen
              (value: string | number): boolean => false, // isEndDoor2LockedCloseAndLockedOpen
              (value: string | number): boolean => false, // isInnerDoor1LockedCloseAndLockedOpen
              (value: string | number): boolean => false, // isInnerDoor2LockedCloseAndLockedOpen
              (value: string | number): boolean => false, // isBistroDoorLockedCloseAndLockedOpen
              (value: string | number): boolean => false, // isPRMDoor1Active
              (value: string | number): boolean => false // isPRMDoor2Active
            ]
          },
          {
            id: 'door-sub-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // outerDoor1IsObstructed
              (value: string | number): boolean => Number(value) === 1, // outerDoor2IsObstructed
              (value: string | number): boolean => Number(value) === 1, // outerDoor3IsObstructed
              (value: string | number): boolean => Number(value) === 1, // outerDoor4IsObstructed
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor1CommunicationError
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor2CommunicationError
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor3CommunicationError
              (value: string | number): boolean => Number(value) === 1, // isOuterDoor4CommunicationError
              (value: string | number): boolean => false, // isEndDoor1MinorError
              (value: string | number): boolean => false, // isEndDoor2MinorError
              (value: string | number): boolean => false, // isInnerDoor1MinorError
              (value: string | number): boolean => false, // isInnerDoor2MinorError
              (value: string | number): boolean => false, // isBistroDoorMinorError
              (value: string | number): boolean => false, // isEndDoor1MajorError
              (value: string | number): boolean => false, // isEndDoor2MajorError
              (value: string | number): boolean => false, // isInnerDoor1MajorError
              (value: string | number): boolean => false, // isInnerDoor2MajorError
              (value: string | number): boolean => false, // isBistroDoorMajorError
              (value: string | number): boolean => false, // isEndDoor1CommunicationError
              (value: string | number): boolean => false, // isEndDoor2CommunicationError
              (value: string | number): boolean => false, // isInnerDoor1CommunicationError
              (value: string | number): boolean => false, // isInnerDoor2CommunicationError
              (value: string | number): boolean => false // isBistroDoorCommunicationError
            ]
          }
        ]
      },

      [TcddSubSystem.OTHER_SYSTEM]: {
        main: [
          {
            id: 'other-main-info-status',
            conditions: [
              (value: string | number): boolean => false, // lightOn
              (value: string | number): boolean => false, // halfLight
              (value: string | number): boolean => Number(value) === 1 // emergencyLight
            ]
          },
          {
            id: 'other-main-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // eventRecorderSourcedEmergency
              (value: string | number): boolean => Number(value) === 1, // ccuMemoryError
              (value: string | number): boolean => Number(value) === 1, // tkysCommunicationError
              (value: string | number): boolean => Number(value) === 1 // wtbCommunicationError
            ]
          }
        ],
        sub: [
          {
            id: 'other-sub-info-status',
            conditions: [
              (value: string | number): boolean => Number(value) === 0, // fireSystemAlarm
              (value: string | number): boolean => Number(value) === 1, // fireExtinguisher1Presence
              (value: string | number): boolean => Number(value) === 1, // fireExtinguisher2Presence
              (value: string | number): boolean => Number(value) === 1, // fireExtinguisher3CabinPresence
              (value: string | number): boolean => Number(value) === 1, // handle1PassengerAlarm
              (value: string | number): boolean => Number(value) === 1, // handle2PassengerAlarm
              (value: string | number): boolean => Number(value) === 1, // handle3PassengerAlarm
              (value: string | number): boolean => Number(value) === 1, // handle4PassengerAlarm
              (value: string | number): boolean => false, // toiletOutOfOrderSignal
              (value: string | number): boolean => Number(value) === 1, // wcSosSignal
              (value: string | number): boolean => false, // toiletActive
              (value: string | number): boolean => false, // contactor1DegradedModeInserted
              (value: string | number): boolean => false, // contactor2DegradedModeInserted
              (value: string | number): boolean => Number(value) === 0, // sandLevelSensor1Bogie1Axle1
              (value: string | number): boolean => Number(value) === 0, // sandLevelSensor2Bogie1Axle1
              (value: string | number): boolean => Number(value) === 0, // sandLevelSensor3Bogie2Axle3
              (value: string | number): boolean => Number(value) === 0, // sandLevelSensor4Bogie2Axle3
              (value: string | number): boolean => Number(value) === 0, // sandLevelSensor5Bogie2Axle4
              (value: string | number): boolean => Number(value) === 0, // sandLevelSensor6Bogie2Axle4
              (value: string | number): boolean => Number(value) === 1, // inhibitionPassengerAlarmActive
              (value: string | number): boolean => Number(value) === 0, // passengersAlarm
              (value: string | number): boolean => Number(value) === 1, // levelWashWaterTank
              (value: string | number): boolean => false, // tailLightRedLeft
              (value: string | number): boolean => false, // tailLightRedRight
              (value: string | number): boolean => false, // dimmedMarkerLightLeftRight
              (value: string | number): boolean => false, // dimmedHeadLightLeft
              (value: string | number): boolean => false, // dimmedHeadLightRight
              (value: string | number): boolean => false, // fullMarkerLightLeftRight
              (value: string | number): boolean => false // fullHeadLightLeftRight
            ]
          },
          {
            id: 'other-sub-info-error',
            conditions: [
              (value: string | number): boolean => Number(value) === 1, // deadManControl
              (value: string | number): boolean => Number(value) === 1, // deadManByPass
              (value: string | number): boolean => Number(value) === 1, // toiletVacuumFailure
              (value: string | number): boolean => Number(value) === 1, // toiletPressureFailure
              (value: string | number): boolean => Number(value) === 1, // toiletCommunicationError
              (value: string | number): boolean => Number(value) === 1, // waterLevelLow
              (value: string | number): boolean => Number(value) === 1, // wasteWaterTankFull
              (value: string | number): boolean => Number(value) === 1, // toiletBowlFull
              (value: string | number): boolean => Number(value) === 1, // toiletSystemAirPressureLow
              (value: string | number): boolean => Number(value) === 1, // eventRecorderError
              (value: string | number): boolean => Number(value) === 0, // fireSystemFault
              (value: string | number): boolean => Number(value) === 1, // fduMinorFault
              (value: string | number): boolean => Number(value) === 1, // fduMajorFault
              (value: string | number): boolean => Number(value) === 1, // fduSevereFault
              (value: string | number): boolean => Number(value) === 0, // deadManFault
              (value: string | number): boolean => Number(value) === 0, // functionOk
              (value: string | number): boolean => Number(value) === 0 // outdoorLightingAutomaticControl
            ]
          }
        ]
      }
    };
  }
}
